"use client";

import { useState } from "react";

import ProductCard from "@/components/card/ProductCard";

import FilterSidebar from "@/components/filter/FilterSidebar";

import AsianBasketFooter from "@/components/footer/AsianBasketFooter";

import { ASIAN_BASKET_DEPARTMENTS } from "@/lib/asianBasketTaxonomy";

import useDepartmentCatalogFilters from "@/hook/useDepartmentCatalogFilters";

import "./filter.css";

export default function DepartmentCatalog({
  departmentSlug,
  products = [],
  initialQuery = "",
}) {
  const [filtersOpen, setFiltersOpen] = useState(false);

  const department =
    ASIAN_BASKET_DEPARTMENTS[departmentSlug] ||
    ASIAN_BASKET_DEPARTMENTS.groceries;

  const filters = useDepartmentCatalogFilters({
    products,
    department,
    departmentSlug,
    initialQuery,
  });

  return (
    <main className="asian-bucket-department-page-main-wrapper">
      <div className="asian-bucket-department-page-width custom-container">
        <div className="asian-bucket-department-layout-main-wrapper">
          <FilterSidebar
            open={filtersOpen}
            onClose={() => setFiltersOpen(false)}
            departmentSlug={departmentSlug}
            department={department}
            categoryNames={filters.categoryNames}
            selectedCategory={filters.selectedCategory}
            onCategoryChange={filters.selectCategory}
            brands={filters.brands}
            brandCounts={filters.brandCounts}
            selectedBrands={filters.selectedBrands}
            onBrandToggle={filters.toggleBrand}
            maxPrice={filters.maxPrice}
            onMaxPriceChange={filters.setMaxPrice}
            dynamicValues={filters.dynamicValues}
            selectedOptions={filters.selectedOptions}
            onOptionToggle={filters.toggleOption}
            stockOnly={filters.stockOnly}
            onStockChange={filters.setStockOnly}
            saleOnly={filters.saleOnly}
            onSaleChange={filters.setSaleOnly}
            onClear={filters.clearFilters}
          />

          <section className="asian-bucket-department-products-main-wrapper">
            {/* BREADCRUMB */}

            <div className="asian-bucket-department-breadcrumb">
              Home
              <span>›</span>
              {department.label}
              {filters.selectedCategory && (
                <>
                  <span>›</span>

                  <strong>{filters.selectedCategory}</strong>
                </>
              )}
            </div>

            {/* HEADING */}

            <div className="asian-bucket-department-heading-main-wrapper">
              <div>
                <h1>{filters.selectedCategory || department.label}</h1>

                <p>
                  Shop Asian Basket{" "}
                  {filters.selectedCategory
                    ? filters.selectedCategory.toLowerCase()
                    : department.label.toLowerCase()}{" "}
                  with authentic quality for your family.
                </p>
              </div>

              <button
                type="button"
                className="asian-bucket-mobile-filter-button"
                onClick={() => setFiltersOpen(true)}
              >
                Filters
              </button>
            </div>

            {/* CHIPS */}

            <div className="asian-bucket-category-chip-row-main-wrapper">
              <div className="asian-bucket-category-chip-filter-main-wrap">
                {filters.chips.map((chip) => (
                  <button
                    key={chip}
                    type="button"
                    className={filters.selectedChip === chip ? "is-active" : ""}
                    onClick={() => filters.setSelectedChip(chip)}
                  >
                    {chip}
                  </button>
                ))}
              </div>

              <div className="asian-bucket-catalog-toolbar-main-wrapper">
                <div className="asian-bucket-catalog-toolbar-spacer" />

                <label className="asian-bucket-catalog-sort-main-wrapper">
                  <span>Sort by:</span>

                  <select
                    value={filters.sort}
                    onChange={(event) => filters.setSort(event.target.value)}
                  >
                    <option value="featured">Featured</option>

                    <option value="name-asc">Name: A–Z</option>

                    <option value="name-desc">Name: Z–A</option>

                    <option value="price-low">Price: Low to High</option>

                    <option value="price-high">Price: High to Low</option>
                  </select>
                </label>
              </div>
            </div>

            {/* PRODUCTS */}

            {filters.visibleProducts.length ? (
              <div className="asian-bucket-department-product-grid">
                {filters.visibleProducts.map((product) => (
                  <ProductCard
                    key={product.storefront_card_id || product.id}
                    product={product}
                  />
                ))}
              </div>
            ) : (
              <div className="asian-bucket-no-products-main-wrapper">
                <img src="/assets/images/empty-image.png" alt="empty image" />
                <h2>No matching products</h2>

                <p>Try another category or clear the filters.</p>

                <button type="button" onClick={filters.clearFilters}>
                  Clear Filters
                </button>
              </div>
            )}
          </section>
        </div>

        <AsianBasketFooter />
      </div>
    </main>
  );
}
